import businessShape from './businessShape'

export default {
    businessShape
}



// WEBPACK FOOTER //
// ./src/store/modules/components/index.js